import axiosInstance from "./axiosInstance";

export const createSubscription = (payload) => {
  return axiosInstance.post("/combat-subscription", payload);
};